import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import Footer from './layout/Footer';
import titleIcon from '../assets/images/title.png';

const Layout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* シンプルなロゴバー */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 3,
          py: 1.5,
          borderBottom: '1px solid rgba(0,0,0,0.06)',
        }}
      >
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            '&:hover': { opacity: 0.7 },
          }}
        >
          <Box
            component="img"
            src={titleIcon}
            alt="AI人事 アイコン"
            sx={{ height: '2.5rem', width: 'auto' }}
          />
        </Box>
      </Box>
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
